import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8.5 16.5a5 5 0 0 1 7 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 8.82a15 15 0 0 1 4.17-2.65", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10.66 5c4.01-.36 8.14.9 11.34 3.76", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16.85 11.25a10 10 0 0 1 2.22 1.68", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 13a10 10 0 0 1 5.24-2.76", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12.01", y1: "20", y2: "20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "WifiOff";
const WifiOff = memo(themed(Icon));
export {
  WifiOff
};
//# sourceMappingURL=wifi-off.js.map
